import module from 'app/module.js'
import template from './template.html'

class AppSesionPasshelpComponent {
  constructor (dialog) {
    this.dialog = dialog
  }

  $close () {
    this.dialog.reject()
  }
}

module.controller('appSesionPasshelp', AppSesionPasshelpComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('app.sesion.pass_help', {
    controller: 'AppSesionPasshelp',
    template,
    controllerAs: '$ctrl',
  })
})



// WEBPACK FOOTER //
// ./src/app/components/sesion/passhelp/component.js